import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import ArrowLeft from "../icons/arrow-left";
import Button from "../ui/button";
import "./styles.scss";

export default function TextHeading({ title = "Пополнить баланс" }: { title: string }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const goBack = () => navigate(-1);

  return (
    <div className="text_heading">
      <Button
        text={t("Back")}
        icon={<ArrowLeft />}
        icon_direction="left"
        className={`btn_dark text_heading_btn`}
        onClick={goBack}
      />
      <h1 className="text_title">{t(title)}</h1>
    </div>
  );
}
